<template>
  <div v-b-popover.hover.auto=mensaje>
    <b-icon  v-if="historico" icon="alarm" animation="cylon animation:" variant="primary"></b-icon>
    <p style="color: #0c69a7;" class="nombreBoton" @click="siguenteFlujo(data.item.idSolicitudEtapa, data.item)" >
      {{ data.item.nombrePaciente }}
    </p>
  </div>
</template>

<script>
import {MotorService} from "@/apiServices/motor/MotorService";
export default {
  name: "BandejaLinkPacienteCentroValidacionComponente",
  props: {
    data: Object,
    resource: Object
  },
  data() {
    return {
      motorServicio : new MotorService(),
      mensaje: "",
      historico: false,
      idPaciente: null
    }
  },
  created() {
    if (this.data.item.solicitudesHistoricas === 1){
      this.historico = true;
      this.mensaje = "Paso por histórico 1 vez";
    }else if( this.data.item.solicitudesHistoricas > 1){
      this.mensaje =  "Paso por histórico " + this.data.item.solicitudesHistoricas + " veces" ;
      this.historico = true;
    }

  },
  methods: {
    siguenteFlujo(idSolicitudEtapa,item) {
      if (item.idEmpleadoEmbajador !== this.$localStorageService.getIdEmpleado()) {
        this.$swal.fire({
          icon: "info",
          html: '<p>Actualiza el presentador, el colaborador asignado es: '+ item.nombreEmbajador + ' </p>'+
          '<p> la información del paciente estará en su perfil en la pestaña "detalle PTI OG"</p>',
          showConfirmButton: true,
          confirmButtonText: "OK",
          allowOutsideClick: false,
        }).then(()=>{
          this.$router.push({name: "paciente", params: {id: item.idPaciente}});
        });
        return false;
      }

      const params = {
        idSolicitudEtapa: idSolicitudEtapa,
        objeto: null
      }

      this.motorServicio
          .obtenerSiguenteFlujo(params)
          .then((respuesta) => {
            let url = respuesta.data.urlPantalla;
            if (respuesta.data.parametros.length > 0) {
              if(respuesta.data.idEtapa == 95){
                url = url + "/"+this.data.item.idPaciente;
              }
              url = url + "/"+item.idPti+'/'+item.idSolicitudEtapa+'/';
              respuesta.data.parametros.forEach((p, i) => {
                url = url + p.valor;
                if (i + 1 < respuesta.data.parametros.length) {
                  url = url + "/";
                }
              });
              url = url + "/" + respuesta.data.idEtapa;
            }
            this.$router.push(url);
          })
          .finally(() => {
            this.loader = false;
          });
    },

    //Por si se deba pasar la lógica del presentador loggeado al back*******************
    procedeSiguienteFlujo(empleado, idSolicitud) {
      var params = {
        idEmpleado: empleado,
        idSolicitudDiagnostico: idSolicitud,
        idUsuarioLogueado: this.$localStorageService.getIdUsuario()
      };

      this.$http
          .put( this.$api + "pti/bandeja/embajador/procedePresentacionEncargado", params)
          .then((response) => {
            if (!response.data.data){
              this.$swal.fire({
                icon: 'success',
                title: response.data.message
              });
            }
          })
          .catch((error) => {
            console.error(error);
            this.$swal.fire({
              icon: "error",
              title: "Ocurrio un error",
              text: error.message,
            });
          });
    },
  }
}
</script>

<style scoped>
.nombreBoton {
  cursor: pointer;
}
.nombreBoton:hover {
  cursor: pointer;
  color: #0c69a7;
  font-weight: bold;
}
</style>
